import { render, staticRenderFns } from "./FactorizationForm.vue?vue&type=template&id=34bcafe7&scoped=true&lang=pug&"
import script from "./FactorizationForm.vue?vue&type=script&lang=js&"
export * from "./FactorizationForm.vue?vue&type=script&lang=js&"
import style0 from "./FactorizationForm.vue?vue&type=style&index=0&id=34bcafe7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bcafe7",
  null
  
)

export default component.exports